import { Box, Grid, IconButton, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React, { useState } from 'react'
import { headingStyle, tableRowLab } from '../../style/LapPageStyle';
import CloseIcon from "@mui/icons-material/Close";
import UseFetchDas28History from '../../helper/UseFetchDas28History';
import { formattedDate, formattedDateWithoutBg } from '../../utils/constantFunctions';


const HistoryDas28 = ({ onClose, patient }) => {
    const { data: historyList, isLoading } = UseFetchDas28History(patient?.id);
    // console.log(historyList, 'historyList')

    const getActivityColor = (value) => {
        const score = parseFloat(value);

        if (score < 2.6) {
            return {
                text: "Remission",
                bg: "#E8F5E9",
                color: "#2E7D32",
                border: "#A5D6A7"
            };
        }

        if (score >= 2.6 && score <= 3.2) {
            return {
                text: "Low Activity",
                bg: "#FFF9C4",
                color: "#e6991dff",
                border: "#f8d25eff"
            };
        }

        if (score > 3.2 && score <= 5.1) {
            return {
                text: "Moderate Activity",
                bg: "#FFE0B2",
                color: "#EF6C00",
                border: "#eab15bff"
            };
        }

        return {
            text: "High Activity",
            bg: "#FFCDD2",
            color: "#C62828",
            border: "#EF9A9A"
        };
    };


    return (
        <Box sx={{ width: "100%", display: 'flex', flexDirection: 'column', justifyContent: "space-between" }}>

            <Box sx={{
                overflowY: 'auto', maxHeight: "80vh", '&::-webkit-scrollbar': {
                    display: 'none',
                },
                '-ms-overflow-style': 'none',
                'scrollbar-width': 'none',
            }}  >

                {/* <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    position="sticky"
                    mb={1}
                >
                    <Box></Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: "8px" }} >

                        <Typography
                            variant="heading_Large"
                            fontWeight={700}
                            gutterBottom
                            sx={headingStyle}
                        >
                            {patient?.full_name} DAS28 Score History
                        </Typography>
                    </Box>
                    <IconButton sx={{ marginBottom: "r0em" }} onClick={onClose}>
                        <CloseIcon size="small" sx={{ color: "red" }} />
                    </IconButton>
                </Box> */}

                <Grid item xs={12}>
                    <TableContainer sx={{ mt: 2, width: "100%" }}>

                        <Table sx={{ width: "100%" }}>
                            <TableHead stickyHeader >
                                <TableRow sx={{ textAlign: "center" }}>
                                    <TableCell
                                        variant="body1_text_bold"
                                        sx={{
                                            color: 'neutral.black',
                                            paddingX: "10px",
                                            textAlign: "center",
                                        }}
                                    >
                                        Date
                                    </TableCell>
                                    <TableCell
                                        variant="body1_text_bold"
                                        sx={{
                                            color: 'neutral.black',
                                            p: "6px",
                                            paddingX: "10px",
                                            textAlign: "center",
                                        }}
                                    >
                                        TJC28
                                    </TableCell>

                                    <TableCell

                                        variant="body1_text_bold"
                                        sx={{
                                            paddingRight: "30px",
                                            color: 'neutral.black',
                                            p: "6px",
                                            paddingX: "10px",
                                            textAlign: "center",
                                        }}
                                    >
                                        SJC28
                                    </TableCell>
                                    <TableCell
                                        variant="body1_text_bold"
                                        sx={{
                                            color: 'neutral.black',
                                            p: "6px",
                                            paddingX: "10px",
                                            textAlign: "center",
                                        }}
                                    >
                                        ESR	                                 </TableCell>
                                    <TableCell
                                        variant="body1_text_bold"
                                        sx={{
                                            color: 'neutral.black',
                                            p: "6px",
                                            paddingX: "10px",
                                            textAlign: "center",
                                        }}
                                    >
                                        CRP
                                    </TableCell>

                                    <TableCell
                                        variant="body1_text_bold"
                                        sx={{
                                            color: 'neutral.black',
                                            p: "6px",
                                            textAlign: "center",
                                            paddingX: "10px",
                                        }}
                                    >
                                        Global Health	                                  </TableCell>

                                    <TableCell
                                        variant="body1_text_bold"
                                        sx={{
                                            color: 'neutral.black',
                                            p: "6px",
                                            textAlign: "center",
                                            paddingX: "10px",
                                        }}
                                    >
                                        DAS28(ESR)
                                    </TableCell>

                                    <TableCell
                                        variant="body1_text_bold"
                                        sx={{
                                            color: 'neutral.black',
                                            p: "6px",
                                            textAlign: "center",
                                            paddingX: "10px",
                                        }}
                                    >
                                        DAS28(CRP)                                </TableCell>

                                    <TableCell
                                        variant="body1_text_bold"
                                        sx={{
                                            color: 'neutral.black',
                                            p: "6px",
                                            textAlign: "center",
                                            paddingX: "10px",
                                        }}
                                    >
                                        Activity Level
                                    </TableCell>
                                </TableRow>
                            </TableHead>



                            {/* 2️⃣ No past score */}
                            {!isLoading &&
                                (!historyList?.payload?.das28_scores ||
                                    historyList.payload.das28_scores.length === 0) && (
                                    <TableRow>
                                        <TableCell colSpan={12} align="center" sx={{ py: 4 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                No DAS28 history available for this patient
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}

                            {isLoading ? (
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={12} sx={{ p: 0 }}>
                                            <Box sx={{ rowGap: 1.2, display: "flex", flexDirection: "column" }}>
                                                {[...Array(5)].map((_, i) => (
                                                    <Skeleton
                                                        key={i}
                                                        variant="rectangular"
                                                        sx={{
                                                            width: "100%",
                                                            height: 50,
                                                            backgroundColor: "#f0f0f0",
                                                        }}
                                                    />
                                                ))}
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )
                                : (
                                    <TableBody>

                                        {historyList?.payload?.das28_scores?.map((score, index) => {
                                            const activity = getActivityColor(score?.das28_esr_score);

                                            return (
                                                <TableRow sx={{ ...tableRowLab, textAlign: "center", backgroundColor: "neutral.blueShadeBg", borderBottom: "8px solid white", borderTop: "2px solid white" }}>
                                                    <TableCell
                                                        sx={{
                                                            borderTopLeftRadius: '20px',
                                                            borderBottomLeftRadius: '20px',
                                                            color: 'neutral.black',
                                                            p: "6px",
                                                            paddingX: "10px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <Typography variant="subTitle116px" sx={{ color: "#3A3A3A" }}>{formattedDateWithoutBg(score?.calculated_at)}</Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        variant="body1_text_bold"
                                                        sx={{
                                                            color: 'neutral.black',
                                                            p: "6px",
                                                            paddingX: "10px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <Typography variant="subTitle116px" sx={{ color: "#3A3A3A" }}> {score?.tjc28} </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        variant="body1_text_bold"
                                                        sx={{
                                                            color: 'neutral.black',
                                                            p: "6px",
                                                            paddingX: "10px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <Typography variant="subTitle116px" sx={{ color: "#3A3A3A" }}> {score?.sjc28} </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        variant="body1_text_bold"
                                                        sx={{
                                                            color: 'neutral.black',
                                                            p: "6px",
                                                            paddingX: "10px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <Typography variant="subTitle116px" sx={{ color: "#3A3A3A" }}> {score?.esr} </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        variant="body1_text_bold"
                                                        sx={{
                                                            color: 'neutral.black',
                                                            p: "6px",
                                                            paddingX: "10px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <Typography variant="subTitle116px" sx={{ color: "#3A3A3A" }}> {score?.crp} </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        variant="body1_text_bold"
                                                        sx={{
                                                            color: 'neutral.black',
                                                            p: "6px",
                                                            paddingX: "10px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <Typography variant="subTitle116px" sx={{ color: "#3A3A3A" }}> {score?.global_health} </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        variant="body1_text_bold"
                                                        sx={{
                                                            color: 'neutral.black',
                                                            p: "6px",
                                                            paddingX: "10px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <Typography variant="subTitle116px" sx={{ color: "#3A3A3A" }}> {score?.das28_esr_score} </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        variant="body1_text_bold"
                                                        sx={{
                                                            color: 'neutral.black',
                                                            p: "6px",
                                                            paddingX: "10px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <Typography variant="subTitle116px" sx={{ color: "#3A3A3A" }}> {score?.das28_crp_score} </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        sx={{
                                                            borderTopRightRadius: "20px",
                                                            borderBottomRightRadius: "20px",
                                                            p: "6px",
                                                            paddingX: "10px",
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                backgroundColor: activity.bg,
                                                                border: `2px solid ${activity?.border}`,
                                                                color: activity.color,
                                                                borderRadius: "14px",
                                                                fontWeight: 600,
                                                                px: 1.5,
                                                                py: 0.7,
                                                                display: "inline-block",
                                                                width: "max-content",
                                                            }}
                                                        >
                                                            {score?.activity_level_description}
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>)
                                        })}
                                    </TableBody>
                                )}
                        </Table>
                    </TableContainer>
                </Grid>
            </Box>
        </Box>

    );
}

export default HistoryDas28;